//////////////////
// IMPORTS
//////////////////
// libraries
import React from "react";
import { createFragmentContainer } from "react-relay";
// defrag results team stats card imports
import { IProps } from "./TailoredDefragSummaryAttendeeStats.d";
import { TailoredDefragSummaryAttendees } from "./TailoredDefragSummaryAttendees";
import { fragments } from "./TailoredDefragSummaryAttendeeStats.gql";
import * as s from "./TailoredDefragSummaryAttendeeStats.styles";
// util
import { helpUrl } from "@constants/site.constant";
// material-ui
import { Info } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class TailoredDefragSummaryAttendeeStatsCmpt extends React.Component<IProps> {
  private renderValueString = (valueString: string, index: number) => {
    const valueParts = valueString.split(" ");
    let value = <span>{valueString}</span>;
    if (valueParts.length > 1) {
      const rest = valueParts.slice(1, valueParts.length).join(" ");
      value = (
        <>
          <span style={s.gainStat}>{valueParts[0]}</span> {rest}
        </>
      );
    }
    return (
      <div style={s.gain} key={index}>
        {value}
      </div>
    );
  };

  public render() {
    const { tailoredDefragCardSummary, org } = this.props;
    const personList =
      tailoredDefragCardSummary &&
      tailoredDefragCardSummary.persons.__typename === "PersonList" &&
      tailoredDefragCardSummary.persons.list &&
      tailoredDefragCardSummary.persons.list.length
        ? tailoredDefragCardSummary.persons
        : null;

    // we only want to show things when we have something to show!
    const showValueStrings =
      tailoredDefragCardSummary &&
      tailoredDefragCardSummary.valueStrings &&
      tailoredDefragCardSummary.valueStrings.length;
    const calendarValueStrings =
      tailoredDefragCardSummary && tailoredDefragCardSummary.calendarValueStrings;

    // const eventCalendarIds = tailoredDefragCardSummary.yourEventMoves ? tailoredDefragCardSummary.yourEventMoves.map(e => e.event.calendarIds).flat() : [];
    let eventCalendarIds: string[] = [];
    if (tailoredDefragCardSummary && tailoredDefragCardSummary.yourEventMoves) {
      tailoredDefragCardSummary.yourEventMoves.forEach((e) => {
        eventCalendarIds = [...eventCalendarIds, ...e.event.calendarIds];
      });
    }

    const hasCalendarIdOutsideEventsBenefit =
      tailoredDefragCardSummary &&
      tailoredDefragCardSummary.impactedOtherCalendarIds.some(
        (c) => eventCalendarIds.indexOf(c) === -1,
      );
    return (
      <div>
        {showValueStrings ? (
          <div>{tailoredDefragCardSummary.valueStrings.map(this.renderValueString)}</div>
        ) : null}
        {personList ? (
          <TailoredDefragSummaryAttendees
            personList={personList}
            org={org}
            calendarValueStrings={calendarValueStrings}
          />
        ) : null}
        {hasCalendarIdOutsideEventsBenefit ? (
          <div style={s.numBenefittedExplanation}>
            <Info style={s.infoIcon} />
            <span>
              Your meeting moves benefited coworkers attending other meetings managed by Clockwise.
            </span>{" "}
            <a
              target="_blank"
              href={`${helpUrl}hc/en-us/articles/360039503831-Meeting-Moves-benefit-the-entire-org`}
              style={s.link}
            >
              Learn more
            </a>
            .
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export const TailoredDefragSummaryAttendeeStats = createFragmentContainer(
  TailoredDefragSummaryAttendeeStatsCmpt,
  fragments,
);
